// todo this will be a global mixing with an accessible method
import Axios from 'axios';
import EventBus from '../EventBus';
import Router from '../router.js';

export const axios = {
  data() {
    return {
      userContext: {},
      photofixrOrders: false,
      instantPrintOrders: false,
      expiry: new Date(Date.now() + 24 * 3600000).getTime()
      // expiry: new Date(Date.now() + 24 * 3600000).toString()
    };
  },
  // watch: {
  //     returnAllCookies() {
  //         console.log('watching')
  //         return this.userContext
  //     }
  // },
  // computed: {
  //     returnAllCookies() {
  //         console.log('computed')
  //         return this.userContext
  //     }
  // },
  created() {
    console.log('expiry');
    console.log(window.sessionStorage.getItem('_loginExpiry'));
    console.log(new Date());
    console.log(window.sessionStorage.getItem('_loginExpiry') < new Date().getTime());

    if (window.sessionStorage.getItem('_loginExpiry') !== null && (window.sessionStorage.getItem('_loginExpiry') < new Date().getTime())) {
      console.log('deleting');
      this.removeLoginSession();

      EventBus.$emit('update', null, null, null, null);
    }
  },

  methods: {
    isUserAuthorised() {
      console.log('************************** evaluating the role');

      if (sessionStorage.getItem('_role') === null) {
        Router.push({
          name: '/'
        });
      } else if (JSON.parse(sessionStorage.getItem('_role')).includes('Customer') || JSON.parse(sessionStorage.getItem('_role')).includes('AccountCustomer')) {
        console.log('not permitted');

        Router.push({
          name: '/'
        });
      }
    },

    removeLoginSession() {
      // window.sessionStorage.removeItem('_loginExpiry')
      // window.sessionStorage.removeItem('_token')
      // window.sessionStorage.removeItem('_customerName')
      // window.sessionStorage.removeItem('_customer')
      // window.sessionStorage.removeItem('_role')
      // window.sessionStorage.removeItem('_customerType')
      window.sessionStorage.clear();
    },

    returnCookie(key) {
      return window.sessionStorage.getItem(key);
      // return this.userContext[key]
    },

    returnContentHeader() {
      return {
        headers: {
          'content-type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Accept-Encoding': 'gzip',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        }
      };
    },

    returnContentHeaderStream() {
      return {
        headers: {
          'content-type': 'application/octet-stream',
          'Access-Control-Allow-Origin': '*',
          'Accept-Encoding': 'gzip',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        }
      };
    },

    returnAcceptHeader() {
      return {
        headers: {
          'accept': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Accept-Encoding': 'gzip',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        }
      };
    },

    returnHeaderNoToken() {
      return {
        headers: {
          'content-type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
          'Accept-Encoding': 'gzip',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        }
      };
    },

    returnHeaderInternal() {
      return {
        headers: {
          'content-type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
          'x-api-key': `${process.env.VUE_APP_ACCOUNTSAPIKEY}`,
          'Authorization': 'Bearer ' + window.sessionStorage.getItem('_token'),
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        }
      };
    },

    returnHeaderUsingToken() {
      return {
        headers: {
          'content-type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
          'Authorization': 'Bearer ' + window.sessionStorage.getItem('_token'),
          // "Accept-Encoding": "gzip"
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        }
      };

    },
    returnFormHeaderUsingToken() {
      return {
        headers: {
          'content-type': 'multipart/form-data',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
          'Authorization': 'Bearer ' + window.sessionStorage.getItem('_token'),
          'Accept-Encoding': 'gzip',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        }
      };
    },

    returnHeaderUsingParameter(singleSignOn) {
      return {
        headers: {
          'content-type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
          'Authorization': 'Bearer ' + singleSignOn,
          'Accept-Encoding': 'gzip',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        }
      };
    },

    persistUserSessionUsingParameter(singleSignOn, response) {
      console.log('response', response);

      window.sessionStorage.setItem('_loginExpiry', this.expiry);
      // window.sessionStorage.setItem('_incompleteOrders', )
      window.sessionStorage.setItem('_token', singleSignOn);
      window.sessionStorage.setItem('_customerName', response.data.result.user.userName);
      window.sessionStorage.setItem('_customer', JSON.stringify(response.data.result.customer));
      window.sessionStorage.setItem('_userId', response.data.result.user.id);
      window.sessionStorage.setItem('_emailAddress', response.data.result.user.emailAddress);
      // window.sessionStorage.setItem('_paygInstantPrintExtraCharge', response.data.result.application.paygInstantPrintExtraCharge);
      window.sessionStorage.setItem('_paygInstantPrintExtraCharge', 5.99);
      window.sessionStorage.setItem('_paygDirectMailrExtraCharge', response.data.result.application.paygDirectMailrExtraCharge);

      if (typeof response.data.result.activeOrders !== 'undefined') {
        if (response.data.result.activeOrders.length >= 1) {
          window.sessionStorage.setItem('_activeOrders', JSON.stringify(1));
          this.reinstateOrders(response.data.result.activeOrders);
        }
      }

      // todo get the user preferences

      if (response.data.result.customer) {
        this.getUserPreferences(response.data.result.customer.ref);
      }

      this.findRole();
      console.log('finished saving cookies');

      EventBus.$emit('update', window.sessionStorage.getItem('_token'), window.sessionStorage.getItem('_customerName'), JSON.parse(window.sessionStorage.getItem('_role')), window.sessionStorage.getItem('_customer'));

    },

    findRole() {
      let tokenPayload = JSON.parse(atob(window.sessionStorage.getItem('_token').split('.')[1]));
      // get role claims string array
      const roles = tokenPayload['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
      console.log('roles ', roles);

      // if (typeof roles !== 'string') {
      //     if (roles.includes('AccountCustomer')) {
      //         window.sessionStorage.setItem('_role', 'Customer')
      //         window.sessionStorage.setItem('_customerType', 'AccountCustomer')
      //     } else {
      //         if (roles.includes('Customer')) {
      //             window.sessionStorage.setItem('_role', 'Customer')
      //             window.sessionStorage.setItem('_customerType', 'Customer')
      //         } else {
      //             // non-customer role such as RpsAdministrator
      //             // only works for single element role array as only the first is taken
      //             window.sessionStorage.setItem('_role', roles[0])
      //         }
      //     }
      // } else {
      window.sessionStorage.setItem('_role', JSON.stringify(roles));
      // }
    },

    clearUserSession() {
      this.removeLoginSession();

      EventBus.$emit('update', null, null, null, null);

      window.location = '/';
    },

    getUserPreferences(customerRef) {
      let skuFinder = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Catalogues/CatalogueBookmarks/?catalogueRef=${process.env.VUE_APP_CATALOGUE_REF}&orderSource=PDFUPLOAD&customerRef=` + customerRef;
      console.log(skuFinder);

      Axios.get(skuFinder, this.returnHeaderUsingToken())
        .then(response => {
          console.log(response);

          const savedPrefs = response.data.result;
          let preferences = [];

          for (let i = 0; i < savedPrefs.length; i++) {
            let current = savedPrefs[i];
            let getPrintDetails = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Catalogues/GetPrintProductDetails/?catalogueRef=${process.env.VUE_APP_CATALOGUE_REF}&orderSource=PDFUPLOAD&priceCode=` + current.priceCode + '&quantity=' + current.quantity;

            console.log(getPrintDetails);

            Axios.get(getPrintDetails, this.returnHeaderUsingToken())
              .then(rifat => {
                let pref = rifat.data.result;
                console.log('print products from GetPrintProductDetails ', pref.printJobSpec.fCode, pref);
                let currentPref = {
                  fCode: pref.printJobSpec.fCode,
                  lamination: pref.printJobSpec.lamination,
                  pageCount: pref.printJobSpec.pageCount,
                  pageHeight: pref.printJobSpec.pageHeight,
                  pageOrientation: pref.printJobSpec.pageOrientation,
                  pageWidth: pref.printJobSpec.pageWidth,
                  quantity: pref.printJobSpec.quantity,
                  stockType: pref.printJobSpec.stockType,
                  stockWeight: pref.printJobSpec.stockWeight,
                  productRef: pref.pricingResult.productRef
                };

                console.log('adding to preferences');
                preferences.push(currentPref);
                console.log('setting preferences');
                sessionStorage.setItem('_myPreferences', JSON.stringify(preferences));
              });
          }
          console.log('PREFERENCES');
          console.log(preferences);
        });
    },

    reinstateOrders(activeOrders) {
      let fixes = {
        basicOrders: 0,
        advanceOrders: 0,
        orderFixes: []
      };

      for (let i = 0; i < activeOrders.length; i++) {
        // activeOrders.reverse
        const activeOrder = activeOrders[i];

        if (activeOrder.orderSource === 'PHOTOFIXR' && this.photofixrOrders === false) {
          if (window.sessionStorage.getItem('_jobId') === null) {
            console.log('**** getting the photofixr job ****');
            // get the job
            const getJob = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + activeOrder.orderSourceId;

            Axios.get(getJob, this.returnHeaderUsingToken())
              .then(response => {
                const job = response.data;
                console.log('**** got the photofixr job ****', job);
                console.log('**** orders length ****', job.orders.length);

                if (job.orders.length > 0) {
                  for (let orderIndex = 0; orderIndex < job.orders.length; orderIndex++) {
                    console.log('**** got the photofixr order from the job ****', job.orders[orderIndex]);
                    const order = job.orders[orderIndex];
                    let taskItems = {
                      brighten_image: '',
                      add_blue_sky: '',
                      increase_vibrancy: '',
                      correct_distortion: '',
                      informationDisabled: true,
                      supportingDisabled: true,
                      add_grass: '',
                      remove_object: '',
                      information: ''
                    };

                    for (let taskIndex = 0; taskIndex < order.taskItems.length; taskIndex++) {
                      const taskItem = order.taskItems[taskIndex];

                      console.log('**** printing the task ****', taskItem.taskType);

                      switch (taskItem.taskType) {
                        case 'Brighten Image':
                          taskItems.brighten_image = true;
                          break;
                        case 'Add Blue Sky':
                          taskItems.add_blue_sky = true;
                          break;
                        case 'Increase Vibrancy':
                          taskItems.increase_vibrancy = true;
                          break;
                        case 'Correct Distortion':
                          taskItems.correct_distortion = true;
                          break;
                        case 'Add Grass':
                          taskItems.add_grass = true;
                          taskItems.information = order.information;
                          taskItems.informationDisabled = false;
                          taskItems.supportingDisabled = false;
                          break;
                        case 'Remove Object':
                          taskItems.remove_object = true;
                          taskItems.information = order.information;
                          taskItems.informationDisabled = false;
                          taskItems.supportingDisabled = false;
                          break;
                      }
                    }

                    if (taskItems.add_grass === true || taskItems.remove_object === true) {
                      console.log('adding advanced');
                      fixes.advanceOrders++;
                    } else if (taskItems.brighten_image === true || taskItems.add_blue_sky === true || taskItems.increase_vibrancy === true || taskItems.correct_distortion === true) {
                      console.log('adding basic');
                      fixes.basicOrders++;
                    }

                    console.log('**** created the fixes taskItem ****', taskItems);
                    fixes.orderFixes.push(taskItems);
                  }
                }

                // set the session information into sessionStorage and update the basket
                // todo might have to set errors but not before test
                // window.sessionStorage.setItem('_errors', JSON.stringify(this.fileTypeErrors));
                window.sessionStorage.setItem('_jobId', activeOrder.orderSourceId);
                console.log('**** set the fixes in sessionStorage ****', fixes);
                window.sessionStorage.setItem('_fixes', JSON.stringify(fixes));
                window.sessionStorage.setItem('_uploadedOrders', JSON.stringify(job.orders.length));

                const basketTotals = {
                  photofixr: job.orders.length
                };

                // todo the basket number needs to be updated
                console.log('**** updating the basket with the right information  ****', basketTotals);

                this.$store.dispatch('incrementPhotofixrTotal', basketTotals);
                EventBus.$emit('activeOrders', null, null, null);
              });
          }

          this.photofixrOrders = true;
        } else if (activeOrder.orderSource === 'PDFUPLOAD') {
          const getJob = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/pdfUpload/Orders/` + activeOrder.orderSourceId;

          console.log('*_*_*_*_ ', getJob);

          Axios.get(getJob, this.returnHeaderUsingToken())
            .then(response => {
              console.log('response from pdfupload restore ', response);
              // todo put inside Axios call - need to be in a position to do an end to end to see the response object of getById
              window.sessionStorage.setItem('_source', JSON.stringify('MYRAVENSWORTH'));
              // window.sessionStorage.setItem('_printJob', JSON.stringify(response.data[0]));
              window.sessionStorage.setItem('_branchCode', JSON.stringify(response.data[0].branchId));
              window.sessionStorage.setItem('_reference', JSON.stringify(response.data[0].customerRef));
              window.sessionStorage.setItem('_propertyName', JSON.stringify(response.data[0].customerRef));

              this.handlePrintJobs(response.data[0]);

              const basketTotals = {
                instantPrint: JSON.parse(window.sessionStorage.getItem('_printJobs'))?.length || 0,
              };

              this.$store.dispatch('incrementPhotofixrTotal', basketTotals);
              EventBus.$emit('activeOrders', null, null, null);
            });

          this.instantPrintOrders = true;
        }
      }
    },

    handlePrintJobs(job) {
      let printJobs = JSON.parse(window.sessionStorage.getItem('_printJobs'));

      if (!(printJobs && printJobs.length)) {
        printJobs = [job];

        window.sessionStorage.setItem('_printJobs', JSON.stringify(printJobs));

        return;
      }

      const index = printJobs.findIndex(printJob => printJob.id === job.id);

      if (index !== -1) {
        printJobs[index] = job;
      } else {
        printJobs.push(job);
      }

      window.sessionStorage.setItem('_printJobs', JSON.stringify(printJobs));
    }
  }
};
